import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CreateMasterProjectButtonProps {
  className?: string;
  labelClassName?: string;
}

const CreateMasterProjectButton = ({ className, labelClassName }: CreateMasterProjectButtonProps): ReactElement => (
  <Button asChild size="sm" className={cn('justify-start gap-2', className)}>
    <Link to="/project/create">
      <Plus className="size-4 shrink-0" />
      <span className={labelClassName}>Nueva inmobiliaria</span>
    </Link>
  </Button>
);

export default CreateMasterProjectButton;
